import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
function Detail() {
  const { id } = useParams();
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [input, setInput] = useState({
    title: "",
    job_description: "",
    company_image_url: "",
    job_qualification: "",
    job_type: "",
    job_tenure: "",
    job_status: 0,
    company_name: "",
    company_city: "",
    salary_min: 0,
    salary_max: 0,
  });
  function formatRupiah(angka) {
    if (angka !== null) {
      var number_string = angka.toString(),
        split = number_string.split(","),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi),
        separator;

      // tambahkan titik jika yang di input sudah menjadi angka ribuan
      if (ribuan) {
        separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
      return rupiah === "0" ? "Free" : "Rp. " + rupiah + ",-";
    }
  }
  const functionEdit = () => {
    setIsLoading(true);
    axios
      .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${id}`)
      .then((result) => {
        let fetchResult = result.data;
        setInput({
          id: fetchResult.id,
          title: fetchResult.title,
          job_description: fetchResult.job_description,
          company_image_url: fetchResult.company_image_url,
          job_qualification: fetchResult.job_qualification,
          job_type: fetchResult.job_type,
          job_tenure: fetchResult.job_tenure,
          job_status: fetchResult.job_status,
          company_name: fetchResult.company_name,
          company_city: fetchResult.company_city,
          salary_min: fetchResult.salary_min,
          salary_max: fetchResult.salary_max,
        });
      })
      .finally(setIsLoading(false));
  };
  useEffect(() => {
    functionEdit();
  }, []);
  return (
    <>
      {isLoading ? (
        <span className="  text-xs font-medium text-blue-800 text-center p-0.5 leading-none rounded-full px-2 dark:bg-blue-900 dark:text-blue-200 absolute -translate-y-1/2 -translate-x-1/2 top-2/4 left-1/2">
          <div role="status">
            <svg
              aria-hidden="true"
              className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        </span>
      ) : (
        <section class="bg-white">
          <div class="gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
            <img
              class="w-full"
              src={input.company_image_url}
              alt="company image"
            />
            <div class="mt-4 md:mt-0">
              <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
                {input.title} ({input.job_type})
              </h2>
              <p class="mb-4 font-light text-black md:text-lg font-semibold">
                {input.company_name} - {input.job_tenure}
              </p>
              <p class="mb-4 font-light text-black md:text-lg">
                Status :<span></span>
                <span>
                  {input.job_description === 0 ? (
                    <span>Closed Hiring</span>
                  ) : (
                    <span>Open Hiring</span>
                  )}
                </span>
              </p>
              <p class="mb-4 font-light text-black md:text-lg">
                City : {input.company_city}
              </p>
              <p class="mb-4 font-light text-black md:text-lg">
                {input.job_description}
              </p>
              <p class="mb-4 font-light text-black md:text-lg">
                Salary : {formatRupiah(input.salary_min)} -{" "}
                {formatRupiah(input.salary_max)}
              </p>
              <button
                class="inline-flex items-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                onClick={() => {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Apply Successed",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  setTimeout(() => {
                    return navigate("/job-vacancy");
                  }, 1000);
                }}
              >
                Apply Now
                <svg
                  class="ml-2 -mr-1 w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
export default Detail;
